import React, { useState, useEffect } from 'react';
import { propertyData } from '../data/mock';

const HeroSection = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
    
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % propertyData.heroImages.length
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section id="hero" className="hero-section">
      {/* Background Images with Crossfade */}
      {propertyData.heroImages.map((image, index) => (
        <div
          key={index}
          className="hero-background"
          style={{
            backgroundImage: `url(${image.url})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            opacity: currentImageIndex === index ? 1 : 0,
            zIndex: 0
          }}
        />
      ))}
      
      {/* Overlay */}
      <div className="hero-overlay" />

      {/* Hero Content */}
      <div className="hero-content" style={{ opacity: isLoaded ? 1 : 0 }}>
        <div style={{ 
          marginBottom: 'var(--spacing-md)',
          fontSize: '1.125rem',
          fontWeight: '500',
          letterSpacing: '0.15em',
          textTransform: 'uppercase',
          color: 'rgba(255, 255, 255, 0.9)'
        }}>
          {propertyData.subtitle}
        </div>
        
        <h1 className="hero-title mb-md">
          {propertyData.title}
        </h1>
        
        <p style={{
          fontSize: 'clamp(1.125rem, 2vw, 1.5rem)',
          color: 'rgba(255, 255, 255, 0.95)',
          marginBottom: 'var(--spacing-xl)',
          maxWidth: '700px',
          margin: '0 auto var(--spacing-xl) auto',
          lineHeight: '1.6'
        }}>
          {propertyData.tagline}
        </p>

        <div style={{ 
          display: 'flex', 
          gap: 'var(--spacing-md)', 
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <a 
            href={propertyData.airbnbUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            style={{ 
              fontSize: '1.125rem',
              padding: '1.125rem 2.75rem',
              background: 'white',
              color: 'var(--color-ocean-deep)'
            }}
          >
            Book Your Stay
          </a>
          <a 
            href="#highlights"
            className="btn-outline"
            style={{ 
              fontSize: '1.125rem',
              padding: '1.125rem 2.75rem',
              borderColor: 'white',
              color: 'white'
            }}
          >
            Explore More
          </a>
        </div>

        {/* Scroll Indicator */}
        <div style={{
          position: 'absolute',
          bottom: '2rem',
          left: '50%',
          transform: 'translateX(-50%)',
          animation: 'bounce 2s infinite'
        }}>
          <div style={{
            width: '30px',
            height: '50px',
            border: '2px solid rgba(255, 255, 255, 0.5)',
            borderRadius: '25px',
            display: 'flex',
            justifyContent: 'center',
            paddingTop: '8px'
          }}>
            <div style={{
              width: '6px',
              height: '10px',
              background: 'rgba(255, 255, 255, 0.7)',
              borderRadius: '3px',
              animation: 'scroll 1.5s infinite'
            }} />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% {
            transform: translateX(-50%) translateY(0);
          }
          40% {
            transform: translateX(-50%) translateY(-10px);
          }
          60% {
            transform: translateX(-50%) translateY(-5px);
          }
        }

        @keyframes scroll {
          0% {
            opacity: 1;
            transform: translateY(0);
          }
          100% {
            opacity: 0;
            transform: translateY(15px);
          }
        }
      `}</style>
    </section>
  );
};

export default HeroSection;
